/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./createGate.defs.js";
export { main as default } from "./createGate.defs.js";
